/***
 *
 *   LOGO
 *   Replace the image in /images with your own logo
 *
 **********/

import { AuthContext, ClassHelper } from 'components/lib';
import Style from './logo.tailwind.js';
import LogoImg from 'assets/icons/Logo-Main_1.svg';
import LogoWhite from 'assets/icons/logo_white2.svg';
import LogoShort from 'assets/icons/Logo-Main_3.png';
import PublicLogo from 'assets/icons/satkaam.png';

import { useContext, useEffect, useReducer, useState } from 'react';
import { useLocation } from 'react-router-dom';

export function Logo(props) {
	const [Logo, setLogoList] = useState({
		color: LogoImg,
		white: LogoWhite,
		short: LogoShort
	});

	const authContext = useContext(AuthContext);
	const location = useLocation();

	const [logoColour, setLogoColour] = useState(props.color ?? "color")
	const [, forceUpdate] = useReducer(x => x + 1, 0);

	// Define Satkaam public Routes
	const orgPublicRoutes = ['/assessments/:assessmentId'];

	// Check if the current route is public
	const isPublicPage = orgPublicRoutes.some((route) => {
		const regex = new RegExp(`^${route.replace(/:\w+/g, '[^/]+')}$`);
		return regex.test(location.pathname);
	});

	useEffect(() => {
		if (authContext?.user?.accounts[0]?.whitelabel) {
			const prevLogoList = Logo;
			if (authContext.user.accounts[0].org_logo) {
				prevLogoList.orgLogo = authContext.user.accounts[0].org_logo;
				setLogoList(prevLogoList)
				setLogoColour("orgLogo")
			}
			forceUpdate()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [authContext])

	const clickUrl = props.path ? process.env.REACT_APP_WEBSITE_URL + props.path : process.env.REACT_APP_WEBSITE_URL

	const logoStyle = ClassHelper(Style, props);

	return (
			<a
				href={clickUrl}
				className={logoStyle}
				onClick={(event) => {
					if (props.onClick) {
						event.preventDefault()
						props.onClick()
					}
				}}
			>
				<img
					style={{
						scale: '1.2',
						height: authContext?.user?.accounts[0]?.whitelabel ? '2.5em' : '',
						marginLeft: '0.5em',
						marigintop: '0.5em'
					}}
					src={isPublicPage ? PublicLogo : Logo[logoColour]}
					alt="Logo"
				/>
			</a>
	);
}
